import React from 'react'

const bannerbottombarAPI = {
    homepage:[
        {
            img:"./assets/images/Homepage/banner/bannerbar/icon1.png",
            counternumber:6,
            name:"Courses"
        },
        {
            img:"./assets/images/Homepage/banner/bannerbar/icon2.png",
            counternumber:30,
            name:"Teachers"
        },
        {
            img:"./assets/images/Homepage/banner/bannerbar/icon3.png",
            counternumber:3846,
            name:"Members"
        },
        {
            img:"./assets/images/Homepage/banner/bannerbar/icon4.png",
            counternumber:12,
            name:"Countries"
        },

    ],
    aboutpage:[
      {
        img:"./assets/images/aboutpage/bannerbottombar/1.png",
        counternumber:100,
        suffix:"K",
        name:"Subscribers"
      },
      {
          img:"./assets/images/aboutpage/bannerbottombar/2.png",
          counternumber:100,
          suffix:"K",
          name:"Teachers"
      },
      {
            img:"./assets/images/aboutpage/bannerbottombar/3.png",
          counternumber:130,
          suffix:"K",
          name:"Members"
      },
      {
            img:"./assets/images/aboutpage/bannerbottombar/4.png",
          counternumber:5,
          suffix:"M",
          name:"Countries"
      },
    ]
}

const BannerBottomBarAPI = () => {
  return (
    <>

    </>
  )
}


export {bannerbottombarAPI}

export default BannerBottomBarAPI